import { useSEO } from '@/hooks/useSEO';

/**
 * Raisy /pitch — the animated raise deck (project109 / RULES_PITCH_DECK v2).
 * One central deck component: name+email gate, terminal boot, 14 animated
 * slides with the RAISY persona, closing interest capture (→ Google Sheets).
 */
export const PitchDeckPage = () => {
  useSEO({
    title: 'Raisy — Every decision leaves a receipt',
    description:
      'Raisy is the AI workforce platform: paste your URL, get a governed, auditable AI workforce — fundraising, sales, recruiting, support — with approval gates and versioned, self-improving kernels. AI prepares. Humans decide.',
    keywords:
      'AI workforce, AI employees, governed autonomy, AI workforce platform, fundraising AI, sales AI, approval gates, audit trail',
    ogTitle: 'Raisy — Every decision leaves a receipt',
    ogDescription: 'A governed AI workforce with approval gates, audit trails, and self-improving kernels.',
    ogImage: 'https://raisy.team/logo.png',
    ogType: 'website',
    canonicalUrl: 'https://raisy.team/pitch',
  });

  return (
    <iframe
      src="/pitch/index.html"
      title="Raisy — Pitch Deck"
      style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 'none' }}
    />
  );
};
